var _path, _path2, _path3, _path4, _g, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFilterIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.5814 11.2728H7.4186C7.18742 11.2728 7 11.0853 7 10.8542C7 10.623 7.18742 10.4355 7.4186 10.4355H24.5814C24.8126 10.4355 25 10.623 25 10.8542C25 11.0853 24.8126 11.2728 24.5814 11.2728Z",
    fill: "#1752AF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.5814 16.7649H7.4186C7.18742 16.7649 7 16.5775 7 16.3463C7 16.1152 7.18742 15.9277 7.4186 15.9277H24.5814C24.8126 15.9277 25 16.1152 25 16.3463C25 16.5775 24.8126 16.7649 24.5814 16.7649Z",
    fill: "#1752AF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.5814 22.2571H7.4186C7.18742 22.2571 7 22.0697 7 21.8385C7 21.6073 7.18742 21.4199 7.4186 21.4199H24.5814C24.8126 21.4199 25 21.6073 25 21.8385C25 22.0697 24.8126 22.2571 24.5814 22.2571Z",
    fill: "#1752AF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1302_1130",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 9,
    width: 5,
    height: 4
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.97754 9H12.6876V12.7101H8.97754V9Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1302_1130)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8326 9C10.3371 9 9.87123 9.19296 9.52086 9.54333C9.1705 9.89371 8.97754 10.3596 8.97754 10.855C8.97754 11.3505 9.1705 11.8164 9.52086 12.1668C9.87123 12.5171 10.3371 12.7101 10.8326 12.7101C11.3281 12.7101 11.7939 12.5171 12.1443 12.1668C12.4947 11.8164 12.6876 11.3505 12.6876 10.855C12.6876 10.3596 12.4947 9.89371 12.1443 9.54333C11.7939 9.19296 11.3281 9 10.8326 9Z",
    fill: "#1752AF"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.0183 15.0355C21.6679 14.6851 21.2021 14.4922 20.7066 14.4922C20.2111 14.4922 19.7453 14.6851 19.3949 15.0355C19.0445 15.3859 18.8516 15.8517 18.8516 16.3472C18.8516 16.8427 19.0445 17.3086 19.3949 17.6589C19.7453 18.0093 20.2111 18.2023 20.7066 18.2023C21.2021 18.2023 21.6679 18.0093 22.0183 17.6589C22.3687 17.3086 22.5616 16.8427 22.5616 16.3472C22.5616 15.8517 22.3687 15.3859 22.0183 15.0355Z",
    fill: "#1752AF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.1419 19.9824C14.6464 19.9824 14.1806 20.1754 13.8302 20.5257C13.4798 20.8761 13.2869 21.342 13.2869 21.8375C13.2869 22.333 13.4798 22.7988 13.8302 23.1492C14.1806 23.4996 14.6464 23.6925 15.1419 23.6925C15.6374 23.6925 16.1033 23.4996 16.4536 23.1492C16.804 22.7988 16.9969 22.333 16.9969 21.8375C16.9969 21.342 16.804 20.8761 16.4536 20.5257C16.1033 20.1754 15.6374 19.9824 15.1419 19.9824Z",
    fill: "#1752AF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIcon);
export default __webpack_public_path__ + "static/media/FilterIcon.73b71eda745569c3e77a301e47bec451.svg";
export { ForwardRef as ReactComponent };